import React, { useContext } from 'react';

// DEPENDENCIES
import { cloneDeep } from 'lodash';

// CONTEXT
import { ListContext } from 'helpers/getListData';

// GLOBAL COMPONENTS
import Filters from 'parts/filters/Filters';

// LOCAL COMPONENTS
import SortFilter from './SortFilter';

// MAIN COMPONENT
const TableFilters = props => {

  // CONTEXT
  const {
    data,
    preferences: {
      filters,
      showColumns
    } = {},
    updateFilter,
    updateFilters
  } = useContext(ListContext) || {};

  // RENDER
  return (
    <Filters
      data={data}
      filters={{
        ...filters,
        showColumns: cloneDeep(showColumns)
      }}
      updateFilter={updateFilter}
      updateFilters={updateFilters}
      {...props}
    />
 )
}

// CHILD COMPONENTS
TableFilters.Button        = Filters.Button;
TableFilters.Select        = Filters.Select;
TableFilters.Date          = Filters.Date;
TableFilters.Sort          = SortFilter;
TableFilters.Search        = Filters.Search;
TableFilters.Spacer        = Filters.Spacer;
TableFilters.Reset         = props => <Filters.Reset tableContext={ListContext} {...props} />;

// EXPORT
export default TableFilters;
